import HeaderPersonal from "../../components/funcionarios/HeaderPersonal";
import BuscadorFichas from "../../components/funcionarios/BuscadorFichas";
import SolicitanteCard from "../../components/funcionarios/SolicitanteCard";
import { Container, Col, Row, Stack } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { buscarSolicitantes } from "../../services/apis_funcionarios";

const styles = {
  scrollable: {
    overflowY: "auto",
    maxHeight: "60vh",
  },
};

function Fichas() {
  const navigate = useNavigate();
  const location = useLocation();

  const [busqueda, setBusqueda] = useState(location.state?.busqueda ?? "");
  const [resultados, setResultados] = useState([]);
  const [buscando, setBuscando] = useState(location.state?.buscando ?? false);
  const [error, setError] = useState(location.state?.error ?? "");

  location.state = null; // Limpiar el estado para evitar reutilización no deseada

  // Búsqueda automática con debounce
  useEffect(() => {
    if (location.state?.resultados?.length) return;

    if (!busqueda.trim()) {
      setResultados([]);
      setError("");
      return;
    }

    if(busqueda.trim().length < 3){
      setResultados([]);
      setError("Ingresa al menos 3 caracteres para buscar.");
      return;
    }

    const timeoutId = setTimeout(async () => {
      setBuscando(true);
      setError("");

      try {
        const busquedaLimpia = busqueda.trim().replace(/[.-]/g, "");
        const data = await buscarSolicitantes(busquedaLimpia);
        setResultados(data.slice(0, 10));
      } catch (err) {
        console.error("Error al buscar:", err);
        setError("Error al realizar la búsqueda. Intenta nuevamente.");
        setResultados([]);
      } finally {
        setBuscando(false);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [busqueda]);

  const handleVerFicha = (idSolicitante) => {
    navigate(`/fichas/${idSolicitante}`, {
      state: {
        busqueda,
        resultados,
        buscando,
        error,
      },
    });
  };

  return (
    <Container fluid className="p-0 m-0 w-100">
      <Row className="g-3">
        <Col md={12}>
          <HeaderPersonal />
        </Col>
        <Col md={12}>
          <BuscadorFichas
            busqueda={busqueda}
            setBusqueda={setBusqueda}
            buscando={buscando}
            error={error}
          />

          {resultados.length > 0 && (
            <div className="mt-3">
              <h3 className="h6 mb-3 text-muted">
                {resultados.length} resultado
                {resultados.length !== 1 ? "s" : ""} encontrado
                {resultados.length !== 1 ? "s" : ""} para "{busqueda}"
              </h3>

              <div style={styles.scrollable}>
                <Stack gap={2}>
                  {resultados.map((solicitante) => (
                    <SolicitanteCard
                      key={solicitante.idS}
                      solicitante={solicitante}
                      onVerFicha={handleVerFicha}
                    />
                  ))}
                </Stack>
              </div>
            </div>
          )}

          {!buscando && busqueda && resultados.length === 0 && !error && (
            <div className="text-center text-muted py-4">
              <i className="bi bi-search" style={{ fontSize: "3rem" }}></i>
              <p className="mt-2">
                No se encontraron resultados para "{busqueda}"
              </p>
            </div>
          )}

          {!busqueda && resultados.length === 0 && (
            <div className="text-center text-muted py-4">
              <i
                className="bi bi-file-earmark-person"
                style={{ fontSize: "3rem" }}
              ></i>
              <p className="mt-2">
                Ingresa un nombre para buscar fichas de estudiantes
              </p>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default Fichas;
